import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const restoreCategoryAction = createAsyncThunk(
    'restore-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/restore-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const restoreCategorySlice = createSlice({
    name: 'restore-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(restoreCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(restoreCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(restoreCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const restoreCategoryReducer = restoreCategorySlice.reducer    